import { c as _c } from "react/compiler-runtime";
import { selectActiveGroupId } from "@/store/groupSlice";
import { FunnelIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { useSelector } from "react-redux";
interface Props {
  readonly open: boolean;
  readonly setOpen: (open: boolean) => void;
}
const GroupsSidebarAppToggle: FC<Props> = t0 => {
  const $ = _c(7);
  const {
    open,
    setOpen
  } = t0;
  const activeGroupId = useSelector(selectActiveGroupId);
  const color = activeGroupId && !open ? "tw-text-primary-400" : "tw-bg-iron-950 tw-text-iron-300";
  const t1 = `tw-fixed tw-mt-2 tw-z-40 tw-bg-iron-950 active:tw-bg-iron-800 tw-border tw-border-l-0 tw-border-solid 
      tw-border-iron-600 tw-p-2 tw-rounded-r-lg  focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out ${color}`;
  let t2;
  if ($[0] !== open || $[1] !== setOpen) {
    t2 = () => setOpen(!open);
    $[0] = open;
    $[1] = setOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FunnelIcon className="tw-w-6 tw-h-6 tw-flex-shrink-0" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2) {
    t4 = <button className={t1} onClick={t2} aria-label="Toggle groups sidebar">{t3}</button>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default GroupsSidebarAppToggle;